import { useCallback } from 'react';
import { setIpqsRiskContext } from 'src/api/risk/ipqs-context';

type FingerprintAgent = Awaited<ReturnType<(typeof import('@fingerprintjs/fingerprintjs'))['default']['load']>>;

let fingerprintPromise: Promise<FingerprintAgent> | null = null;

function getFingerprintAgent() {
  fingerprintPromise =
    fingerprintPromise ??
    import('@fingerprintjs/fingerprintjs').then(({ default: fingerprintLibrary }) => fingerprintLibrary.load());
  return fingerprintPromise;
}

export function useDeviceFingerprint() {
  const syncDeviceFingerprint = useCallback(async () => {
    const agent = await getFingerprintAgent();
    const result = await agent.get();

    setIpqsRiskContext({
      internalDeviceId: result.visitorId,
      internalDeviceConfidence: result.confidence?.score,
    });

    return result.visitorId;
  }, []);

  return { syncDeviceFingerprint };
}
